import React from 'react';
import './index.css';

function QuickLinks() {
  return (
    <div className="wrapper">
      <ul className='quicklinks'>
        <li className='encuentro'><a href="google.com">
          <i></i>
          <span>Encontranos</span>
        </a></li>
        <li className='contacto'><a href="google.com">
          <i></i>
          <span>Contactanos</span>
        </a></li>
        <li className='ayuda'><a href="google.com">
          <i></i>
          <span>Te ayudamos</span>
        </a></li>
      </ul>
    </div>
  );
}

export default QuickLinks;
